import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {CALENDAR_TYPES, TIntCalendarOutput} from "../../shared";

@Component({
  selector: 'int-month-calendar',
  templateUrl: './int-month-calendar.component.html',
  styleUrls: ['./int-month-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntMonthCalendarComponent{

  _currentDate: [Date | null, Date | null] = [null, null];

  @Input() set currentDate( date: Date | null | [Date | null, Date | null]) {
    this._currentDate = Array.isArray(date) ? date : [date, null];
  };
  @Input() type: keyof typeof CALENDAR_TYPES = 'single';
  @Output() onChange = new EventEmitter<TIntCalendarOutput>();

  onSelect(selected: TIntCalendarOutput) {
    this.onChange.emit(selected);
  }
}
